/*

SaiKrishna 10/06/2022 3075154998 Removed unnecessary console.log statements
Suresh Peddavoora 10/26/2022 3075154998  Added Class Name for Table Enhancements
Ashraf 10/30/2022 3075154998 fixed table pagination issue
saikrishna 11/03/2022 3075154998 changed the paginationOptions
Raghu 11/30/2022 3075154998 Table footer styling fixes
*/
import React, {useState} from 'react';
// import MaterialTable from "material-table";
import {Grid} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {tablePageRows, defaultRows} from '../../../../../constants/ReusableTablePagination';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {TablePagination} from '@material-ui/core';

export default function FilterTable({filterData, setOpen, setRowData, setIsEdit}) {
  const [rows, setRows] = useState(defaultRows);
  const columns = [
    {
      title: 'SeqNo',
      field: 'seqNo',
      render: (rowData) => {
        const rowSeqNo = rowData?.tableData?.id ?
          rowData?.tableData?.id + 1 :
          rowData?.tableData?.id === 0 ?
            1 :
            '';
        filterData[rowData?.tableData?.id].seqNo = rowSeqNo;
        return rowSeqNo;
      },
    },
    {
      title: 'Filter Code',
      field: 'filterCode',
    },
    {
      title: 'Description',
      field: 'description',
    },
  ];
  return (
    <>
      <Grid item xs={12} className="">
        <div className="custom-table global-field-table">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={filterData}
            textAlign="left"
            options={{
              toolbar: false,
              search: false,
              pageSize: rows,
              pageSizeOptions: tablePageRows,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              )}}
            actions={[
              (rowData) => {
                return {
                  icon: 'edit',
                  tooltip: 'Edit',
                  onClick: () => {
                    setOpen(true);
                    setRowData(rowData);
                    setIsEdit(true);
                  },
                };
              },
              (rowData) => {
                return {
                  icon: 'delete',
                  tooltip: 'Delete',
                  onClick: () => {
                    // handleDelete(rowData);
                  },
                };
              },
            ]}
          />
        </div>
      </Grid>
    </>
  );
}
